import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "favorite-fill_07763",
  "use": "favorite-fill_07763-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" id=\"favorite-fill_07763\">\n    <path d=\"M11.572 4.27l-3.54-.514L6.448.548a.521.521 0 0 0-.9 0l-1.58 3.208-3.54.514a.5.5 0 0 0-.277.853l2.562 2.5-.606 3.526a.5.5 0 0 0 .726.527L6 10.008l3.167 1.665a.5.5 0 0 0 .726-.527L9.287 7.62l2.562-2.5a.5.5 0 0 0-.277-.853v.003z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol